import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MnoMappingService } from '../mno-mapping.service';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';

import { MatChipInputEvent, MatChipEvent } from '@angular/material/chips';
import { FloorMapService } from '../../floor-maps-manager/floor-map.service';

@Component({
  selector: 'app-mno-mapping-edit',
  templateUrl: './mno-mapping-edit.component.html',
  styleUrls: ['./mno-mapping-edit.component.scss']
})
export class MnoMappingEditComponent {
  newMno = {
    region: '',
    mno: '',
    mcc: [],
    mnc: [],
    bands4G: [] ,
    bands5G: [],
    bandsNsa5G: []
  };
  errormessage: any;
  uniqueError: any;
  rowData: any[] = [];
  regions: any;
  selectedRegion: any;
  selectedMno: any;
  selectedFourG: any[] = [];
  selectedNsaFiveG: any[] = [];
  selectedFiveG: any[] = [];
  regionsList: any[];
  mnosList: any[] = [];
  fourGbandsList: any[];
  fiveGbandsList: any[];
  nsafiveGbandsList: any[];
  validationCheck: boolean;
  setDisplayRegion: any;
  bandDetailsData: any;
  setMNOMapName: any;
  error: string;
  message: string;
  jsonObj: any;
  enableButton: boolean = true;
  title: any;
  formFieldsChange: boolean = false;
  action: any;
  id: any;
  isSpinner: boolean = false;
  enableSaveButton: boolean = false;
  disabledRegionInput = false;
  filteredOptions: string[] = [];
  regionsArray: any;
  mccInput: string;
  mncInput: string;
  constructor(public dialogRef: MatDialogRef<MnoMappingEditComponent>,
    private mnoMappingService: MnoMappingService,
    private matDialog: MatDialog,
    private toast: ToastrService,
    private floormapService: FloorMapService,
private cdr: ChangeDetectorRef,
    private router: Router,
    private modalService: NgbModal,
    @Inject(MAT_DIALOG_DATA) public inputdata: any
  ) { }

  ngOnInit(): void {
    this.title = this.inputdata.name ? this.inputdata.name : 'New Mno';
    this.action = this.inputdata.action ? this.inputdata.action : 'Create';
    this.id = this.inputdata?.params.data?._id;
    // this.validationCheck = this.inputdata?.params.data?._source?.groups_count ? true : false
    this.setMNOMapName = this.inputdata?.params.data?._source?.template_name;
    this.selectedRegion = this.inputdata?.params.data?._source?.region;
    this.selectedMno = this.inputdata?.params.data?._source?.mno;
    this.selectedFourG = this.inputdata?.params.data?._source?.bands.bands_4g;
    this.selectedFiveG = this.inputdata?.params.data?._source?.bands.bands_5g;
    this.selectedNsaFiveG = this.inputdata?.params.data?._source?.bands.bands_nsa_5g;
    this.getMnoMapDetails();
    this.getTemplatesList();
    this.getRegionData();
    if (this.action == 'Edit') {
      this.getGroupsCount();
    } else {
      this.validationCheck = false;
    }
  }
  getGroupsCount() {
    var queryarray;
    queryarray = {
      "size": 0,
      "aggs": {
        "distinct_template": {
          "terms": {
            "field": "template_name",
            "size": 1000
          }
        }
      }
    }
    this.mnoMappingService.getGroupsCount(queryarray).subscribe((data: any) => {
      let groupsCount = data['result']['aggregations']['distinct_template']['buckets']
      var countsoftemplate = groupsCount.filter((item) => {
        return this.inputdata?.params.data?._source?.template_name == item.key;
      })
      if (countsoftemplate.length > 0) {
        if (countsoftemplate[0]?.doc_count > 0) {
          this.validationCheck = true;
        } else {
          this.validationCheck = false
        }
      } else {
        this.validationCheck = false
      }
    })
  }
  changeEvent() {
    this.formFieldsChange = true;
  }
  onCancel(content) {
    if (this.action == 'Create' && content && this.formFieldsChange && (this.setMNOMapName || this.selectedRegion || this.selectedMno || this.selectedFourG?.length > 0 || this.selectedFiveG?.length > 0 || this.selectedNsaFiveG?.length > 0)) {
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', modalDialogClass: "width-550", windowClass: 'custom-modal-zindex', backdrop: 'static',
        keyboard: false}).result.then(

      );
    } else if (this.action == 'Edit' && content && this.formFieldsChange) {
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', modalDialogClass: "width-550", windowClass: 'custom-modal-zindex', backdrop: 'static',
        keyboard: false}).result.then(

      );
    }
    else {
      this.dialogRef.close();
    }
  }


  getTemplatesList() {
    this.mnoMappingService.getAllMnos('', '', '').subscribe((data: any) => {
      this.rowData = data.result.hits;
      if (this.action == 'Edit') {
        let index = this.rowData.findIndex(x => x._id == this.id);
        this.rowData.splice(index, 1);
      }
    })
  }

  getMnoMapDetails() {
    var array = []
    var mnoobj = this.selectedRegion && this.action != 'Edit' ? [{ mno: "Add New" }] : [];
    this.mnoMappingService.getMnoBandDetails().subscribe((data: any) => {
      this.bandDetailsData = data['result']['hits'];
      var regions = this.action == 'Edit' ? [] : ["Add New"];
      this.bandDetailsData.map(element => {
        regions.push(element._source.region);
        array.push({ region: element._source.region });
      })
      this.regionsList = [...new Set(regions)].sort();
      this.cdr.detectChanges();
      this.setDisplayRegion = array;
      
      this.bandDetailsData.map(element => {
        if (element._source.region == this.selectedRegion) {
          let obj = {
            mno: element._source.mno,
            mcc: element._source?.mcc,
            mnc: element._source?.mnc
          }
          mnoobj.push(obj)
        }
      })
      this.mnosList = mnoobj;
      var bands_4g = [];
      var bands_5g = [];
      var bands_nsa_5g = [];
      this.bandDetailsData.map(element => {
        if (element._source.region == this.selectedRegion && element._source.mno == this.selectedMno) {
          bands_4g = element._source?.band_4g;
          bands_5g = element._source?.band_5g
          bands_nsa_5g = element._source?.band_nsa_5g
        }
      })
      this.fourGbandsList = bands_4g;
      this.fiveGbandsList = bands_5g;
      this.nsafiveGbandsList = bands_nsa_5g;
    })
  }

  onRegionChange(item: any, newMno) {
    if(item !== 'Add New'){
      this.disabledRegionInput = true;
      this.newMno.region = this.selectedRegion;
    var mnoobj = this.selectedRegion && this.action != 'Edit' ? [{ mno: "Add New" }] : [];
    this.selectedFiveG = [];
    this.selectedFourG = [];
    this.selectedNsaFiveG = [];
    this.bandDetailsData.map(element => {
      if (element._source.region == this.selectedRegion) {
        let obj = {
          mno: element._source.mno,
          mcc: element._source?.mcc,
          mnc: element._source?.mnc
        }
        mnoobj.push(obj)
      }
    })
    this.mnosList = mnoobj;
    this.error = '';
    this.selectedMno = undefined;
    this.enableButtonsmethod();
  } else {
    this.newMno.region = '';
    this.mnosList = [];
    this.disabledRegionInput = false;
    this.modalService.open(newMno, { ariaLabelledBy: 'modal-basic-title', modalDialogClass: "width-400", windowClass: 'custom-modal-zindex', backdrop: 'static',
      keyboard: false
    }).result.then(
    )

  }
  }

  onMnoChange(item, newMno) {
    if(item.mno !== 'Add New'){
    var bands_4g = [];
    var bands_5g = [];
    var bands_nsa_5g = [];
    this.error = '';
    this.enableButtonsmethod();
    this.selectedFiveG = [];
    this.selectedFourG = [];
    this.selectedNsaFiveG = [];
    this.bandDetailsData.map(element => {
      if (element._source.region == this.selectedRegion && element._source.mno == this.selectedMno) {
        bands_4g = element._source?.band_4g;
        bands_5g = element._source?.band_5g
        bands_nsa_5g = element._source?.band_nsa_5g
      }
    })
    this.fourGbandsList = bands_4g;
    this.fiveGbandsList = bands_5g;
    this.nsafiveGbandsList = bands_nsa_5g;
  } else {
    this.modalService.open(newMno, { ariaLabelledBy: 'modal-basic-title', modalDialogClass: "width-400", windowClass: 'custom-modal-zindex', backdrop: 'static',
      keyboard: false }).result.then(
    )
  }
  }

  onFourgChange(item) {
    this.error = '';
    this.enableButtonsmethod();
  }
  onNsaFivegChange(item) {
    this.error = '';
    this.enableButtonsmethod();
  }
  onFivegChange(item) {
    this.error = '';
    this.enableButtonsmethod();
  }
  markerClickEvent(marker) {
    this.selectedRegion = marker.label;
  }

  // onsetMNOMapName(event) {
  //   this.enableButtonsmethod();
  // }
  onsetMNOMapName(event) {
    if (this.setMNOMapName) {
      this.setMNOMapName = this.setMNOMapName.replace(/[^a-zA-Z0-9 ]/g, ''); // Allows only alphanumeric & spaces
    }
    this.enableButtonsmethod();
  }
  enableButtonsmethod() {
    var uniqueness;
    const obj = this.rowData.filter((item) => {
      if (this.setMNOMapName) {
        return item._source.template_name == this.setMNOMapName.trim()
      } else {
        return;
      }
    });
    if (obj.length > 0) {
      this.error = `${this.setMNOMapName} already exists`
      uniqueness = false;
    } else {
      uniqueness = true;
      this.error = '';
    }
    if (this.selectedFourG && this.selectedFourG?.length > 0 || this.selectedFiveG && this.selectedFiveG?.length > 0 || this.selectedNsaFiveG && this.selectedNsaFiveG?.length > 0) {

      this.message = '';
    } else {
      this.message = 'Please select at least one type of bands';
    }
    if (uniqueness && this.setMNOMapName && this.selectedRegion && this.selectedMno && (this.selectedFourG?.length > 0 || this.selectedFiveG?.length > 0 || this.selectedNsaFiveG?.length > 0)) {
      this.jsonObj = {
        template_name: this.setMNOMapName,
        region: this.selectedRegion,
        mno: this.selectedMno,
        bands: {
          'bands_4g': this.selectedFourG,
          'bands_5g': this.selectedFiveG,
          'band_nsa_4g': this.selectedNsaFiveG,
        },

      };
      this.enableButton = false
    } else {
      this.enableButton = true
    }
  }
  submitMno() {
    var mcc = '';
    var mnc = '';
    this.getTemplatesList();
    this.mnosList.forEach((item) => {
      if (item.mno == this.selectedMno) {
        mcc = item.mcc;
        mnc = item.mnc;
      }
    })
    this.isSpinner = true;
    if (this.setMNOMapName && this.selectedRegion && this.selectedMno && (this.selectedFourG?.length > 0 || this.selectedFiveG?.length > 0 || this.selectedNsaFiveG?.length > 0)) {
      this.error = ''
      const obj1 = this.rowData.filter((item) => item._source.template_name == this.setMNOMapName.trim());
      if (obj1.length > 0) {
        this.error = `${this.setMNOMapName} already exists`
      } else {
        this.error = '';
        const obj = {
          template_name: this.setMNOMapName.trim(),
          region: this.selectedRegion,
          mno: this.selectedMno,
          bands: {
            'bands_4g': this.selectedFourG,
            'bands_5g': this.selectedFiveG,
            'bands_nsa_5g': this.selectedNsaFiveG,
          },
          mcc: mcc,
          mnc: mnc,
          status: "Active"
        }
        if (this.action == 'Edit') {
          this.mnoMappingService.updateMno(obj, this.id).subscribe((res: any) => {
            this.isSpinner = false;
            if (res && res.status == 200) {
              this.toast.success("MNO Map Updated successfully")
              this.regionsList = []
              this.mnosList = []
              this.fourGbandsList = []
              this.selectedFiveG = [];
              this.selectedFourG = [];
              this.selectedNsaFiveG = [];
              this.enableButton = true;
              this.selectedRegion = '';
              this.setMNOMapName = '';
              this.selectedMno = '';
              var data = res?.result;
              this.onCancel('');
            } else if (res.status == 400) {
              this.error = `${this.setMNOMapName} already exists`
            } else {
              this.toast.error("Status: " + res.status + " received!")
            }
          })
        } else {
          this.mnoMappingService.createMno(obj).subscribe((res: any) => {
            this.isSpinner = false;
            if (res && res.status == 200) {
              this.toast.success("MNO Map saved successfully")
              this.regionsList = []
              this.mnosList = []
              this.fourGbandsList = []
              this.selectedFiveG = [];
              this.selectedFourG = [];
              this.selectedNsaFiveG = [];
              this.enableButton = true;
              this.selectedRegion = '';
              this.setMNOMapName = '';
              this.selectedMno = '';
              var data = res?.result;
              this.onCancel('');
            } else if (res.status == 400) {
              this.error = `${this.setMNOMapName} already exists`
            } else {
              this.toast.error("Status: " + res.status + " received!")
            }
          })
        }
      }
    } else {
      this.error = "Please select all mandatory fields";
    }
  }
  redirectToGroupManager() {
    this.dialogRef.close();
    this.router.navigate(['groups-manager'])
  }
  validateName(e) {
    var k;
    k = e.charCode;    //  k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
  separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];
  // Add code to the corresponding array
  addCode(type: 'mcc' | 'mnc', event: MatChipInputEvent): void {
    const input = event.input // Retrieve the input element
    const value = (event.value || '').trim();

    if (value && !isNaN(Number(value))) {
      this.newMno[type].push(Number(value)); // Add the number to the array
    }

    // Clear the input field
    if (input) {
      input.value = '';
    }
  }

  // Remove a code from the array
  removeCode(type: 'mcc' | 'mnc', code: number): void {
    const index = this.newMno[type].indexOf(code);
    if (index >= 0) {
      this.newMno[type].splice(index, 1);
    }
  }
  handlePaste(type: 'mcc' | 'mnc', event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text');
    if (clipboardData) {
      // Split the pasted text into an array by commas or spaces
      const values = clipboardData.split(/[\s,]+/);
  
      // Filter and add only valid numeric values
      values.forEach(value => {
        const trimmedValue = value.trim();
        if (trimmedValue && !isNaN(Number(trimmedValue)) && !this.newMno[type].includes(Number(trimmedValue))) {
          this.newMno[type].push(Number(trimmedValue));
        }
      });
    }
  }
  
  addBand(type: string, event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

     // Convert value to a number and ensure it is valid
  const numberValue = Number(value);

  if (!isNaN(numberValue) && numberValue > 0) {  // Only add positive numbers
    this.newMno[`bands${type}`].push(numberValue);
  }

    if (input) {
      input.value = '';
    }
    this.enablesubmitButtonsmethod();
  }

  removeBand(type: string, band: string): void {
    const index = this.newMno[`bands${type}`].indexOf(band);
    if (index >= 0) {
      this.newMno[`bands${type}`].splice(index, 1);
    }
    this.enablesubmitButtonsmethod();
  }

  pasteBands(type: string, event: ClipboardEvent): void {
    event.preventDefault();
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData?.getData('text') || '';

    pastedText
      .split(',')
      .map(band => band.trim())
      .filter(band => band)
      .forEach(band => this.newMno[`bands${type}`].push(band));
  }
    // Handle form submission
    createNewMno() {
      const obj = {
        band_4g : this.newMno.bands4G,
        band_5g : this.newMno.bands5G,
        band_nsa_5g: this.newMno.bandsNsa5G,
        mcc: this.newMno.mcc,
        mnc: this.newMno.mnc,
        mno: this.newMno.mno,
        region: this.newMno.region,
        isTemporary: true
      }
    this.mnoMappingService.createNewMno(obj).subscribe((res)=>{
      this.getMnoMapDetails();
      setTimeout(() => {
      this.getMnoMapDetails();        
      }, 2000);
      this.closeModal();

    })
      
    }
    closeModal() {
      !this.disabledRegionInput ?  this.selectedRegion = null : '';
      this.selectedMno = null;
      this.newMno.bands4G = [];
      this.newMno.bands5G = [];
      this.newMno.bandsNsa5G = [];
      this.newMno.mno = '';
      this.newMno.mcc = [];
      this.newMno.mnc = [];
      this.mccInput = '';	
      this.mncInput = '';
      this.modalService.dismissAll(); // Closes the modal
    }
    allowOnlyNumbers(event: KeyboardEvent): void {
      const allowedKeys = ['Backspace', 'Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight', 'Delete', 'space'];
      if (allowedKeys.indexOf(event.key) !== -1) {
          return; // Allow these keys
      }
      // Prevent non-numeric characters
      if (!/[0-9]/.test(event.key)) {
          event.preventDefault();
      }
  }
  newMnoChange(){
    this.enablesubmitButtonsmethod();
  }
  enablesubmitButtonsmethod() {
    let uniqueness;
    const mnoList = this.bandDetailsData.filter((item) => {
      return item._source.region == this.newMno.region.trim();
    })
    const obj = mnoList.filter((item) => {
      if (this.newMno.mno) {
        return item._source.mno == this.newMno.mno.trim()
      } else {
        return;
      }
    });
    if (obj.length > 0) {
      this.uniqueError = `${this.newMno.mno} already exists`
      uniqueness = false;
    } else {
      uniqueness = true;
      this.uniqueError = '';
    }
    if (this.newMno.bands4G && this.newMno.bands4G.length > 0 || this.newMno.bands5G && this.newMno.bands5G.length > 0 || this.newMno.bandsNsa5G && this.newMno.bandsNsa5G.length > 0) {

      this.errormessage = '';
    } else {
      this.errormessage = 'Please select at least one type of bands';
    }
    if (uniqueness && this.newMno.mno &&  (this.newMno.bands4G.length > 0 || this.newMno.bands5G.length > 0 || this.newMno.bandsNsa5G.length > 0)) {
     
      this.enableSaveButton = false
    } else {
      this.enableSaveButton = true
    }
  }
  
  selectCountry(country: string): void {
    this.newMno.region = country;
    this.filteredOptions = []; // Clear the dropdown
  }
  newRegionChange(e) {
    this.enablesubmitButtonsmethod();
    this.filteredOptions = this._filter(e);
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.regionsArray.filter(option => option.toLowerCase().includes(filterValue));
  }
  getRegionData() {
    this.floormapService.getRegions().subscribe((response: any) => {
      this.regions = response
      this.regionsArray = this.regions.map(item => item.name ? item.name : []);
    })
  }
  
}